// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__nmE0G","image":"Header_image__1oClN","name":"Header_name__MYT1L","info":"Header_info__2d3F6","infoRow":"Header_infoRow__1IBiQ"};